import {
  analyticsadmin_v1alpha,
  type analyticsadmin_v1beta,
} from "googleapis/build/src/apis/analyticsadmin";
import { z } from "zod/v4";

export type GaStream =
  analyticsadmin_v1beta.Schema$GoogleAnalyticsAdminV1betaDataStream;

export type GaAccount =
  analyticsadmin_v1beta.Schema$GoogleAnalyticsAdminV1betaAccountSummary;

export type GaPropertySummary =
  analyticsadmin_v1alpha.Schema$GoogleAnalyticsAdminV1alphaPropertySummary;

export type GaAudience =
  analyticsadmin_v1alpha.Schema$GoogleAnalyticsAdminV1alphaAudience;

export const GoogleGaAudienceSchema = z.object({
  testGroupId: z.uuid(),
  audienceId: z.string().nullish(),
});

export type GoogleGaAudienceType = z.infer<typeof GoogleGaAudienceSchema>;

export type Ga4ExperienceEvent = {
  exp_variant_string: string;
  send_to?: string;
};
